import { USER_ROLE } from 'configs/constants';

const { OWNER, STUDENT, FREE_STUDENT } = USER_ROLE;

export const getPreviewTypes = () => [
  {
    label: 'general.producer',
    value: OWNER,
    role: OWNER
  },
  {
    label: 'general.student',
    value: STUDENT,
    role: STUDENT
  },
  {
    label: 'general.free_student',
    value: FREE_STUDENT,
    role: FREE_STUDENT
  }
];
